/**
 * Guess OEM + fleet family from aircraft_type / model so we can filter MPD revisions.
 */
export function guessFleetFromModel(model) {
  const m = String(model || "").toUpperCase().replace(/\s+/g, " ").trim();
  if (!m) return { oem: null, fleetFamily: null, label: null };
  if (/\bA3(18|19|20|21)\b/.test(m) || /A320|A319|A321|A318/.test(m)) {
    return { oem: "AIRBUS", fleetFamily: "A320", label: "Airbus A320 family" };
  }
  // Classic NG first (737-800 must not be read as MAX 737-8)
  if (/\b737-700\b/.test(m) || /\b737-800\b/.test(m) || /\b737-900\b/.test(m) || /\b737NG\b/.test(m)) {
    return { oem: "BOEING", fleetFamily: "B737NG", label: "Boeing 737 NG" };
  }
  if (
    /\bMAX\b/.test(m) ||
    /\b737-8200\b/.test(m) ||
    /\b737-10\b/.test(m) ||
    /\b737-8\b/.test(m) ||
    /\b737-9\b/.test(m) ||
    /^737-8$/.test(m) ||
    /^737-9$/.test(m)
  ) {
    return { oem: "BOEING", fleetFamily: "B737MAX", label: "Boeing 737 MAX" };
  }
  if (/\b737\b/.test(m) || /B737|737-/.test(m)) {
    return { oem: "BOEING", fleetFamily: "B737", label: "Boeing 737 family" };
  }
  if (/\bATR\s*72\b/.test(m) || /ATR72|72-212/.test(m)) {
    return { oem: "ATR", fleetFamily: "ATR72", label: "ATR 72" };
  }
  if (/\bATR\s*42\b/.test(m) || /ATR42|42-5/.test(m)) {
    return { oem: "ATR", fleetFamily: "ATR42", label: "ATR 42" };
  }
  if (/\bATR\b/.test(m)) {
    return { oem: "ATR", fleetFamily: "ATR", label: "ATR" };
  }
  return { oem: null, fleetFamily: null, label: m };
}

/** True if an MPD revision is a reasonable match for the aircraft model. */
export function revisionMatchesFleet(revision, fleet) {
  if (!fleet?.oem) return true;
  const oem = String(revision?.oem || "").toUpperCase();
  if (oem && oem !== fleet.oem) return false;
  const ft = String(revision?.fleetType || "").toUpperCase();
  const models = (revision?.aircraftModels || []).map((x) => String(x).toUpperCase());
  const fam = fleet.fleetFamily;
  if (!fam) return oem === fleet.oem;
  if (fam === "A320") {
    return /A320|A318|A319|A321/.test(ft) || models.some((x) => /A3(18|19|20|21)/.test(x)) || !ft;
  }
  if (fam === "B737MAX") {
    if (ft === "B737NG") return false;
    return /B737MAX|^B737$|737/.test(ft) || models.some((x) => /737-8\b|737-9\b|737-10|8200|MAX/.test(x)) || ft === "B737" || !ft;
  }
  if (fam === "B737NG") {
    if (ft === "B737MAX") return false;
    return /B737NG|^B737$|737/.test(ft) || models.some((x) => /737-700|737-800|737-900|NG/.test(x)) || ft === "B737" || !ft;
  }
  if (fam === "B737") {
    return /737|B737/.test(ft) || models.some((x) => /737/.test(x)) || !ft;
  }
  if (fam === "ATR72") {
    return /ATR\s*72|ATR72/.test(ft) || models.some((x) => /72/.test(x)) || /ATR/.test(ft);
  }
  if (fam === "ATR42") {
    return /ATR\s*42|ATR42/.test(ft) || models.some((x) => /42/.test(x)) || /ATR/.test(ft);
  }
  return oem === fleet.oem;
}
